import { useState } from "react";
import { Reveal } from "./Reveal";

const EMAIL = "khushitulsiyan495@gmail.com";

export const Contact = () => {
  const formInitialDetails = {
    name: '',
    email: '',
    phone: '',
    message: ''
  }
  const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState(null);

  const onFormUpdate = (category, value) => {
      setFormDetails({
        ...formDetails,
        [category]: value
      })
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setStatus(null);
    try {
      let response = await fetch("/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify(formDetails),
      });
      let result = await response.json();
      if (response.ok && result.code === 200) {
        setStatus({ success: true, message: `Thanks, ${formDetails.name}! Your message is on its way. I'll reply to ${formDetails.email}.` });
        setFormDetails(formInitialDetails);
      } else {
        setStatus({ success: false, message: response.status === 400 ? result.status : "Sorry, your message couldn't be sent." });
      }
    } catch {
      setStatus({ success: false, message: "Sorry, your message couldn't be sent." });
    }
    setSending(false);
  };

  return (
    <section className="contact" id="contact">
      <Reveal as="h2" className="contact-title">Let's work together</Reveal>
      <Reveal as="p" className="contact-lead" delay={100}>
        Tell me about your project and I'll get back to you by email.
      </Reveal>
      <Reveal className="contact-body" delay={200}>
        <form onSubmit={handleSubmit}>
          <div className="form-grid">
            <label className="field">
              <span>Name</span>
              <input type="text" autoComplete="name" required value={formDetails.name} onChange={(e) => onFormUpdate('name', e.target.value)} />
            </label>
            <label className="field">
              <span>Email</span>
              <input type="email" autoComplete="email" required placeholder="you@example.com" value={formDetails.email} onChange={(e) => onFormUpdate('email', e.target.value)} />
            </label>
            <label className="field field-wide">
              <span>Phone <em>(optional)</em></span>
              <input type="tel" autoComplete="tel" value={formDetails.phone} onChange={(e) => onFormUpdate('phone', e.target.value)} />
            </label>
            <label className="field field-wide">
              <span>Message</span>
              <textarea rows="5" required placeholder="What would you like to build?" value={formDetails.message} onChange={(e) => onFormUpdate('message', e.target.value)}></textarea>
            </label>
          </div>
          <button type="submit" className="btn btn-ink btn-lg" disabled={sending}>{sending ? "Sending..." : "Send message"}</button>
          {status && (
            <p role="status" className={`form-status ${status.success ? "success" : "danger"}`}>
              {status.message}
              {!status.success && <> Please email me at <a href={`mailto:${EMAIL}`}>{EMAIL}</a>.</>}
            </p>
          )}
        </form>
        <p className="contact-alt">Prefer email? <a href={`mailto:${EMAIL}`}>{EMAIL}</a></p>
      </Reveal>
    </section>
  )
}
